import React from "react";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import styles from "../styles/triple-3d-carousel.module.scss";
import classNames from "classnames";

class Triple3dCarouselItemProps extends BaseProps {
  itemIndex: Boolean;
  radius: Number;
  angle: Number;
  currentDegrees: Number;
  itemClassName: String;
  activeItemClassName: String;
  onItemClick: Function;
  isActiveItem: Function;
  isSecondaryItem: Function;
  secondaryItemScale: Number;
}

export const Triple3dCarouselItem = ((props: Triple3dCarouselItemProps) => {
  const isActiveItemConst = props.isActiveItem(props.itemIndex)
  const isSecondaryItemConst = props.isSecondaryItem(props.itemIndex)
  const itemProps = {
    className: classNames(styles.item, props.itemClassName,
        {[styles.active_item]: isActiveItemConst, [props.activeItemClassName]: isActiveItemConst,
          [styles.secondary_item]: isSecondaryItemConst}),
    onClick: () => props.onItemClick && props.onItemClick(props.itemIndex),
    style: {
      transform: 'rotateY(' + (-props.currentDegrees) + 'deg)' + (isSecondaryItemConst ? `scale(${props.secondaryItemScale || 0.6})` : (isActiveItemConst ? 'scale(1)' : 'scale(0)'))
    }
  }

  const itemContainer = {
    className: classNames(styles.item_container),
    style: {
      transform: 'rotateY(' + (props.itemIndex * props.angle) + 'deg) translateZ(' + props.radius + 'px) rotateY(-' + (props.itemIndex * props.angle) + 'deg)'
    }
  };

  return (
    <div {...itemContainer}>
      <div {...itemProps}>
        {
          props.children
        }
      </div>
    </div>
  )
});